import { InputType, SpecType } from './module.enum';
import {
  DumbConfig,
  Items,
  ResponseItem,
  Label,
  ResponseRange,
} from './modules.interface';

export const dumbConfig = (
  specs: any,
  responseListType?: SpecType,
  inputType?: InputType,
): DumbConfig => {
  return {
    heading: specs.titles[0]?.l10nKey,
    subHeading: specs.titles[1]?.l10nKey,
    responseList: getResponseList(
      specs.assessment.values,
      responseListType,
      inputType,
    ),
    instructions:
      specs.instructions && specs.instructions.length >= 1
        ? getInstructions(specs.instructions)
        : [],
    note: getNotes(specs.assessment.values),
    data: specs.data ? createData(specs.data) : [],
  };
};

export const getResponseList = (
  specs: any,
  responseListType?: SpecType,
  inputType?: InputType,
) => {
  const questions = getQuestionsByType(specs, responseListType);
  if (inputType === InputType.ITEMS) {
    return createResponseItems(questions);
  }
  if (inputType === InputType.RANGE) {
    return createResponseRanges(questions);
  }
  return getDefaultQuestionList(questions);
};

export const getQuestionsByType = (specs: any, type?: SpecType) => {
  return specs.filter((question: any) => {
    return question.type === type;
  });
};

export const getNotes = (specs: any) => {
  const clinicalNotes = getQuestionsByType(specs, SpecType.CLINICAL_NOTES);
  return {
    key: clinicalNotes.length ? clinicalNotes[0].key : '',
    label: clinicalNotes.length ? clinicalNotes[0].l10nKey : '',
  };
};

export const createResponseRanges = (questionList: any): ResponseRange[] => {
  // for range when type is list we need to get the first item of the list array,
  // QUESTION: can there be two lists?
  return questionList[0].list?.map((item: any) => {
    return {
      key: item.key,
      label: item.value.l10nKey,
      range: formatRangeValues(item.value.range.min, item.value.range.max),
    };
  });
};

export const formatRangeValues = (min: number, max: number): number[] => {
  const numbers = [];
  for (let i = min; i <= max; i++) {
    numbers.push(i);
  }
  return numbers;
};

export const createResponseItems = (questionList: any): ResponseItem[] => {
  return questionList.map((question: any) => {
    return {
      key: question.key,
      notTestedKey: question.notTested.key,
      label: question.label?.l10nKey,
      items: formatQuestionsWithItemValues(question),
    };
  });
};

const formatQuestionsWithItemValues = (question: any): Items[] => {
  return question.items?.map((item: any) => {
    return {
      value: item.responseKey,
      text: item.l10nKey,
    };
  });
};

export const getDefaultQuestionList = (questionList: any): Label[] => {
  return questionList.map((question: any) => {
    return { key: question.key, label: question.l10nKey };
  });
};

export const getVOMSQuestionFromSpecs = (question: any) => {
  return {
    notTested: false,
    rowId: question.rowId,
    key: question.rowLabelL10n.key,
    label: question.rowLabelL10n.key,
    headache: question.headache,
    dizziness: question.dizziness,
    nausea: question.nausea,
    fogginess: question.fogginess,
    comment: question.comment,
    convergenceNearPointMeasurement1: question.convergenceNearPointMeasurement1,
    convergenceNearPointMeasurement2: question.convergenceNearPointMeasurement2,
    convergenceNearPointMeasurement3: question.convergenceNearPointMeasurement3,
  };
};

export const getInstructions = (instructions: any): Label[] => {
  return instructions.flatMap((instruction: any) => {
    return instruction.content.map((content: any) => {
      return {
        key: content.l10nKey,
        label: content.l10nValue,
        audience: instruction.audience,
      };
    });
  });
};

export const createData = (specs: any): any => {
  if (specs.length === 1) {
    // For digits backwards data creation
    return createDataForDigitBackwards(specs);
  }
  // For immediate memory data creation
  return createDataForImmediateMemory(specs);
};

export const createDataForDigitBackwards = (specs: any) => {
  return specs[0].items.map((item: Label) => {
    return { key: item.l10nItem.key, value: item.l10nItem.value };
  });
};

export const createDataForImmediateMemory = (specs: any) => {
  return specs.map((item: any) => {
    return item.items.map((_item: Label) => {
      return { key: _item.l10nItem.key, value: _item.l10nItem.value };
    });
  });
};
